import React from 'react';
import Grid from "@mui/material/Grid";
import Typography from '@mui/material/Typography';
import Link from "@mui/material/Link";
import {useStyles as classes} from "../styles/styles";

const ContactUs = () => {

    return (
        <>
            <Typography variant="h5" color='primary' sx={{...classes.title, marginLeft: {xs: '2rem', md: '4rem'}, marginTop: {xs: '1rem', md: '1.5rem'}}}>Contact Us</Typography>
            <Grid
                container
                spacing={3}
                sx={{
                    justifyContent: "center"
                }}
            >
                <Grid size={12}>
                    <Typography variant='subtitle2' sx={{fontSize: {xs: '.8rem', md: '1.3rem'}, margin: {xs: '1rem 1.5rem', md: '.3rem 3rem'}}}>
                        NEUMO Payments can be contacted by calling Customer Service at (888) 407–0931
                        (Monday through Friday 8am – 5pm Mountain Time). You can also email our
                        Customer Service Department at any time at <Link
                        href="mailto:citepaysupport@avenuinsights.com">citepaysupport@avenuinsights.com</Link>.
                    </Typography>
                </Grid>
            </Grid>
        </>
    );
}

export default ContactUs;
